var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":_vm.item.pinned ? 'green' : 'grey'},on:{"click":_vm.togglePinned}},[_c('v-icon',[_vm._v(_vm._s(_vm.item.pinned ? 'mdi-pin' : 'mdi-pin-off'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }